import {AnyAction} from "redux";
import {RootAction} from "./types";

export const setRedirect = (payload: string): AnyAction => ({
    type: RootAction.REDIRECT,
    payload,
})
